export const initialState = {
  filters: {},
  educationMaterials: [],
  educationMaterial: {},
  loading: false,
  totalCount: 0
};
